import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchInstallationsWithoutPaggination} from "../components/Installations/installationsApi";
import {
    addTableRow,
    crateTableApi,
    deleteTableApi,
    editTableApi,
    fetchAllDevicesOnInstallation,
    fetchAllTableLocations,
    fetchAllTables,
    fetchDeviceTypes,
    getDynamicTable,
    getTableLocations
} from "../components/TableConfig/TableConfigApi";
import {displayNotification} from "./notification";


export const getInstallationDevices = createAsyncThunk(
    'api/installations/devices',
    async (installationId) => {
        const response = await fetchAllDevicesOnInstallation(installationId)
        return response.data
    }
)

export const getInstallationSelectData = createAsyncThunk(
    '/api/installations/all',
    async () => {
        const response = await fetchInstallationsWithoutPaggination();
        return response.data
    }
)
export const getAllTableLocations = createAsyncThunk(
    "/api/installations/locations/all",
    async (installationId) => {
        const response = await fetchAllTableLocations(installationId)
        return response.data
    }
)

export const addDynamicTableRow = createAsyncThunk(
    "/api/installations/tableviews/rows",
    async ({installationId, tableId, selectedOption}, {dispatch}) => {

        try {
            await addTableRow(installationId, tableId, selectedOption)
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Uspješno dodana lokacija",
                title: "Tabele"
            }))
        } catch (e) {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: "Greška prilikom dodavanja lokacije",
                title: "Tabele"
            }))
        }
        dispatch(setShowAddRowModal({show: false, id: tableId}))
        dispatch(getDynamicTableAndLocations({
            installationId: installationId,
            tableId: tableId,
        }))
    }
)

export const getDynamicTableList = createAsyncThunk(
    '/api/installations/tableviews',
    async (installationId) => {
        const response = await fetchAllTables(installationId)
        return response.data
    }
)

export const getDynamicTableAndLocations = createAsyncThunk(
    'table/locations',
    async ({
               installationId, tableId, pagination = {
            current: 1, pageSize: 10, total: 0
        }
           }) => {

        const tableResponse = await getDynamicTable(installationId, tableId, pagination)

        return {tableResponse, pagination}
    }
)

export const editDynamicTable = createAsyncThunk(
    'tableviews/id/edit',
    async ({installationId, tableId}, {getState, dispatch}) => {

        let table = getState().dynamicTable.tableList.find((table) => table.id === tableId)

        let editObject = {
            name: table.name, description: table.description, displayOrder: table.displayOrder, columns: table.columns
        }

        try {
            await editTableApi(installationId, tableId, editObject)
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Uspješno izmjenjena tabela",
                title: "Tabele"
            }))
        } catch (e) {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: "Greška prilikom izmjene tabele",
                title: "Tabele"
            }))
        }
        dispatch(getDynamicTableList(installationId))

    }
)

export const deleteDynamicTable = createAsyncThunk(
    "tableviews/id/delete",
    async ({installationId, tableId}, {dispatch}) => {
        try {
            await deleteTableApi(installationId, tableId)
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Uspješno obrisana tabela",
                title: "Tabele"
            }))
        } catch (e) {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: "Greška prilikom brisanja tabele",
                title: "Tabele"
            }))
        }
        dispatch(getDynamicTableList(installationId))
        dispatch(setShowDeleteModal({show: false, id: tableId}))
    }
)

export const getUniqDeviceParams = createAsyncThunk(
    '/api/devicetypes',
    async () => {
        const response = await fetchDeviceTypes()
        const readableParameters = []
        const commandProducers = []
        response.data.map((device) => {
            readableParameters.push(...device.readableParameters)
            commandProducers.push(...device.commandProducers)
        })

        const uniqReadableParameters = [...new Set(readableParameters)];
        const uniqCommandProducers = [...new Set(commandProducers)];
        return {uniqReadableParameters, uniqCommandProducers}
    }
)

export const createTable = createAsyncThunk(
    '`/api/installations/tableviews`',
    async ({installationId, data}, {dispatch}) => {
        try {
            await crateTableApi(installationId, data)
            dispatch(displayNotification({
                notificationStatus: "success",
                message: "Uspješno kreirana tabela",
                title: "Tabele"
            }))
        } catch (e) {
            dispatch(displayNotification({
                notificationStatus: "error",
                message: "Greška prilikom kreiranja tabele",
                title: "Tabele"
            }))
        }

        dispatch(setShowCreateModal(false))
        dispatch(getDynamicTableList(installationId))
    }
)

const initialState = {
    installationSelect: {
        selected: {
            label: "",
            value: null
        },
        options: [],
        loading: false
    },
    tableList: [],
    tableListLoading: false,
    deviceParams: {
        loading: false,
        uniqueReadableParams: [],
        uniqueCommandProducers: []
    },
    installationLocationsSelect: {
        options: [],
        loading: false
    },
    allDevicesSelect: {
        options: [],
        loading: false
    },
    showCreateModal: false,
    showDeleteModal: false,
    deleteModals: [],
    addRowModals: [],
    addColumnModals: [],
    showAddColumnModal: false,
}

export const dynamicTableData = createSlice({
    name: "dynamicTable",
    initialState,
    reducers: {
        setInitState: () => initialState,
        setSelectedInstallation: (state, action) => {
            state.installationSelect.selected = action.payload
        },
        setShowCreateModal: (state, action) => {
            state.showCreateModal = action.payload
        },
        initializeDeleteModal: (state, action) => {
            state.deleteModals = [...state.deleteModals, {show: false, id: action.payload}]
        },
        unmountDeleteModal: (state, action) => {
            state.deleteModals = state.deleteModals.filter(modal => modal.id !== action.payload)
        },
        setShowDeleteModal: (state, action) => {
            state.deleteModals.find(modal => modal.id === action.payload.id).show = action.payload.show
        },
        initializeAddRowModal: (state, action) => {
            state.addRowModals = [...state.addRowModals, {show: false, id: action.payload}]
        },
        unmountAddRowModal: (state, action) => {
            state.addRowModals = state.addRowModals.filter(modal => modal.id !== action.payload)
        },
        setShowAddRowModal: (state, action) => {
            state.addRowModals.find(modal => modal.id === action.payload.id).show = action.payload.show
        },
        initializeAddColumnModal: (state, action) => {
            state.addColumnModals = [...state.addColumnModals, {show: false, id: action.payload}]
        },
        unmountAddColumnModal: (state, action) => {
            state.addColumnModals = state.addColumnModals.filter(modal => modal.id !== action.payload)
        },
        setShowAddColumnModal: (state, action) => {
            state.addColumnModals.find(modal => modal.id === action.payload.id).show = action.payload.show
        },
        setTableColumns: (state, action) => {
            state.tableList = state.tableList.map((table) => {

                if (table.id === action.payload.id) {
                    table.columns = action.payload.tempCols
                }

                return table
            })
        },
        setTableColumnNewState: (state, action) => {
            state.tableList = state.tableList.map((table) => {
                if (table.id === action.payload.tableid) {
                    table.columns = table.columns.map((col) => {
                        if (col.id === action.payload.id) {
                            return action.payload.data
                        } else {
                            return col
                        }
                    })
                }
                return table
            })
        },
        deleteTableColumn: (state, action) => {
            state.tableList = state.tableList.map((table) => {
                if (table.id === action.payload.tableId) {
                    table.columns = table.columns.filter((col) => col.id !== action.payload.id)
                }
                return table
            })
        },
        addTableColumn: (state, action) => {
            state.tableList = state.tableList.map((table) => {
                if (table.id === action.payload.tableId) {
                    table.columns.push(action.payload.data)
                }
                return table
            })
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getInstallationSelectData.pending, (state) => {
                state.installationSelect.loading = true;
            })
            .addCase(getInstallationSelectData.rejected, (state) => {
                state.installationSelect.loading = false
            })
            .addCase(getInstallationSelectData.fulfilled, (state, action) => {
                state.installationSelect.loading = false
                state.installationSelect.options = action.payload
            })
            .addCase(getInstallationDevices.pending, (state) => {
                state.allDevicesSelect.loading = true;
            })
            .addCase(getInstallationDevices.rejected, (state) => {
                state.allDevicesSelect.loading = false
            })
            .addCase(getInstallationDevices.fulfilled, (state, action) => {
                state.allDevicesSelect.loading = false
                state.allDevicesSelect.options = action.payload
            })
            .addCase(getAllTableLocations.pending, (state) => {
                state.installationLocationsSelect.loading = true;
            })
            .addCase(getAllTableLocations.rejected, (state) => {
                state.installationLocationsSelect.loading = false
            })
            .addCase(getAllTableLocations.fulfilled, (state, action) => {
                state.installationLocationsSelect.loading = false
                state.installationLocationsSelect.options = action.payload
            })
            .addCase(getUniqDeviceParams.pending, (state) => {
                state.deviceParams.loading = true;
            })
            .addCase(getUniqDeviceParams.rejected, (state) => {
                state.deviceParams.loading = false
            })
            .addCase(getUniqDeviceParams.fulfilled, (state, action) => {
                state.deviceParams.loading = false
                state.deviceParams.uniqueReadableParams = action.payload.uniqReadableParameters
                state.deviceParams.uniqueCommandProducers = action.payload.uniqCommandProducers
            })
            .addCase(getDynamicTableList.pending, (state) => {
                state.tableListLoading = true;
            })
            .addCase(getDynamicTableList.rejected, (state) => {
                state.tableListLoading = false;
            })
            .addCase(getDynamicTableList.fulfilled, (state, action) => {
                state.tableListLoading = false;
                state.tableList = action.payload.map((table) => {
                    return {
                        ...table,
                        pagination: {
                            current: 1, pageSize: 10, total: 0
                        },
                        loading: false,
                    }
                })
            })
            .addCase(getDynamicTableAndLocations.pending, (state, action) => {
                state.tableList = state.tableList.map((table) => {

                    if (table.id === action.meta.arg.tableId) {
                        table.loading = true;
                    }

                    return table
                })
            })
            .addCase(getDynamicTableAndLocations.rejected, (state) => {

            })
            .addCase(getDynamicTableAndLocations.fulfilled, (state, action) => {
                state.tableList = state.tableList.map((table) => {

                    if (table.id === action.payload.tableResponse.data.id) {
                        table.rows = action.payload.tableResponse.data.rows
                        table.pagination = action.payload.pagination
                        table.pagination.total = action.payload.tableResponse.data.numRows
                        table.loading = false
                    }

                    return table
                })
            })
    }
})
export const {
    setSelectedInstallation,
    setShowCreateModal,
    setTableColumns,
    setShowDeleteModal,
    setShowAddRowModal,
    setTableColumnNewState,
    deleteTableColumn,
    setShowAddColumnModal,
    addTableColumn,
    initializeAddRowModal,
    setInitState,
    unmountAddColumnModal,
    initializeAddColumnModal,
    unmountAddRowModal,
    unmountDeleteModal,
    initializeDeleteModal
} = dynamicTableData.actions
export default dynamicTableData.reducer;